import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { environment } from '../../environments/environment';
import * as $ from 'jquery';
import { ClientDetailsService } from '../services/client-login-details.service';
import { NotificationService } from '../feature-modules/admin/service/notification.service';
import { EncriptDecriptService } from '../services/encriptdecript';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginData: any;
  loginFormGroup: FormGroup;
  presentEnvironment = '';
  passwordType: boolean = false;
  public CLIENT_DETAILS: any;
  public ftpRootDir = environment['ftpHost']+environment['ftpRootDir'];
  public bannerPath = this.ftpRootDir?this.ftpRootDir:environment['cloudPath'];
  public clientCode = '';
  public errorMessage = '';
  public emailRegex = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
  public passwordRegex = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}$';
  public userObj;
  @ViewChild('emailRef') emialInputRef:ElementRef;
  constructor(private userService: UserService,
    private router: Router,private notification:NotificationService,
    private clientDetailsService: ClientDetailsService,
    private encriptDecript:EncriptDecriptService,
    private activtedRoute: ActivatedRoute, private formBuilder: FormBuilder) {
    this.activtedRoute.paramMap.subscribe((params: ParamMap) => {
      this.clientCode = params.get('code')!=''?params.get('code'):'';
      this.clientDetailsService.loadClientLoginDetails(this.clientCode).then(clientdata => {
        this.CLIENT_DETAILS = clientdata;
      }).catch(
        error => {
          this.CLIENT_DETAILS = '';
        }
      );
    });
    this.errorMessage =localStorage.errorMessage?localStorage.errorMessage:'';
    sessionStorage.clear();
    localStorage.clear();
  }

  ngOnInit() {
    $(document).ready(function () {
      $('input').attr('autocomplete', 'off');
    });
    this.loginForm();
    this.emialInputRef.nativeElement.focus();
    this.subscribeloginForm();
  }
  subscribeloginForm() {
    this.loginFormGroup.valueChanges.subscribe(value => {

    })
  }

  public loginForm() {
    this.loginFormGroup = this.formBuilder.group({
      emailId: ['', [Validators.required, Validators.pattern(this.emailRegex)]],
      passwordHash: ['', [Validators.required]]
    })
  }


  public login() {
    this.errorMessage = '';
    if(this.loginFormGroup.valid){
    this.userService.login(this.loginFormGroup.value).subscribe(
      response => {
        this.loginData = response;
        if (response.status.success !== 'Success' && response.status.success == 'Fail') {
          this.errorMessage = response.status.message;
        } else {
          this.encriptDecript.setKyeToLocalStorage('token',response.token);
          // this.encriptDecriptService.getKeyLocalStorage('token')=response.token;
          localStorage.isLogin=true;
          this.encriptDecript.setToLocalStorage('userObject' , this.loginData.data);
          this.userObj = this.encriptDecript.getLocalStorage('userObject');
          const userDetail = JSON.parse(this.userObj);
          const role = userDetail.roles[0];
          localStorage.setItem('logo',this.clientCode);
          if (this.loginData.data.isAdmin === true) {
           this.encriptDecript.setToLocalStorage('dashboardURL' , '/admin/dashboard');
            this.router.navigate(['/admin/dashboard']);
          } else {
            let routeNavigation: any;
            this.encriptDecript.setToLocalStorage('dashboardURL' , '/admin/dashboard');
            for (let i = 0; i < role.applicationRolePermission.length; i++) {
              if (role.applicationRolePermission[i].isUpdate ||
                role.applicationRolePermission[i].isWrite ||
                role.applicationRolePermission[i].isDelete) {
                return routeNavigation = this.router.navigate(['/admin/dashboard']);
              } else {
                this.encriptDecript.setToLocalStorage('userName' , this.loginData.data.firstName);
                this.encriptDecript.setToLocalStorage('email' , this.loginData.data.emailId); 
                this.encriptDecript.setToLocalStorage('dashboardURL' , '/user/dashboard/browse');
                routeNavigation = this.router.navigate(['/user/dashboard/browse']); }
            }
            return routeNavigation;
          }
        }
      },
      (error) => {
        this.errorMessage = 'Server Error';
        this.notification.errorNotification();
      });
    }
  }

  public get emailId(): AbstractControl {
    return this.loginFormGroup.get('emailId');
  }

  public get passwordHash(): AbstractControl {
    return this.loginFormGroup.get('passwordHash');
  }


}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/login/login.component.ts